import { DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { enableProdMode, ErrorHandler, importProvidersFrom, InjectionToken, LOCALE_ID } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  TitleStrategy,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withRouterConfig
} from '@angular/router';
import { AppComponent } from '@zaoblako/web/core/components/app.component';
import { CoreRoutes } from '@zaoblako/web/core/core.router';
import { ErrorInterceptor } from '@zaoblako/web/core/interceptors/error.interceptor';
import { TokenInterceptor } from '@zaoblako/web/core/interceptors/token.interceptor';
import { GlobalErrorHandler } from '@zaoblako/web/core/services/error-handler.service';
import { CustomTitleStrategy } from '@zaoblako/web/core/strategy/custom.title.strategy';
import { FormStoreService } from '@zaoblako/web/shared/components/form-sidebar/services/form-store.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { environment } from './environments/environment';

export const INTL_RTF = new InjectionToken<Intl.RelativeTimeFormat>('');

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(
      CoreRoutes,
      withEnabledBlockingInitialNavigation(),
      withRouterConfig({ onSameUrlNavigation: 'ignore' }),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
    ),
    importProvidersFrom(HttpClientModule),
    provideAnimations(),
    { provide: LOCALE_ID, useValue: 'ru-RU' },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: TitleStrategy, useClass: CustomTitleStrategy },
    {
      provide: INTL_RTF,
      useFactory: () => new Intl.RelativeTimeFormat('ru')
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    MessageService,
    ConfirmationService,
    DecimalPipe,
    FormStoreService
  ]
}).catch(console.error);
